module.exports = __webpack_public_path__ + "static/media/Justification.71c73e64.png";